import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-solid.css";
import { cn } from "../utils/cn.ts";
import { FontStyles } from "../utils/font-styles.ts";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";

const iconStyles = "text-loch fa-sharp fa-solid fa-sparkles my-auto";

export const PropertyHighlight = () => {
  const { highlight } = usePropertyDetailsContext();
  return (
    highlight && (
      <section className="flex flex-col md:flex-row p-3.5 rounded-md border border-loch bg-loch-50 gap-3 mt-3 md:mt-0">
        <i aria-hidden="true" className={cn(iconStyles, "text-[24px] !hidden md:!block")} />
        <div className="flex flex-col gap-1.5">
          <div className="flex gap-1.5">
            <i aria-hidden="true" className={cn(iconStyles, "text-[16px] !block md:!hidden")} />
            <div className={cn(FontStyles["body-l"], "text-north-sea font-semibold leading-snug md:leading-snug")}>
              Property highlight:
            </div>
          </div>
          <p className={cn(FontStyles["body-md"], "text-slate")}>{highlight}</p>
        </div>
      </section>
    )
  );
};
